export const baseUrl='http://165.22.196.58:8080/keygenes/';
export const projectName='KeyGenes';
